import addHours from 'date-fns/addHours';
// import 'isomorphic-fetch';
import Cookie from 'js-cookie';

// Utils
import { LOG } from '../helpers/utils';
import env from '../helpers/env';

class GZHBase {
  constructor() {
    /**
     * Product ID
     * @type {number}
     */
    this.siteId = 909;
    /**
     * Site Name
     * @type {string}
     */
    this.jornal = 'ZH';
    /**
     * Check environment
     */
    this.env = env();
    /**
     * Messages object
     * @type {[*]}
     * @private
     */
    this._messages = [
      { key: 'ERROR', message: ':( Erro inesperado', type: 'error' }
    ];
    /**
     * Default time expiration used on cookies
     * @type {{number}}
     */
    this.expirationTimes = (24 * 7) * 2;// two weekes in hours
    /**
     * Remove sub-domain from domain host
     * @type {string}
     */
    this._cookieDomain = `.${window ? window.location.hostname.replace(/^[^.]+\./g, '') : 'clicrbs.com.br'}`;

    /**
     * Expiration date Date instance
     * @type {Date}
     */
    this.expiration_date = new Date();
    LOG('[ GZHBase ]', 'constructor');
  }
  /**
   * return messages to present on front
   * @param key
   * @returns {*}
   */
  getMessages(key) {
    let message = null;
    for (const index in this._messages) {
      if (this._messages[index].key === key) {
        message = this._messages[index];
      }
    }
    LOG('[ GZHBase ]', 'getMessages', key, message);
    if (!message && key !== 'ERROR') {
      return this.getMessages('ERROR'); // generic return error
    }
    return message;
  }
  /**
   * @param Token from WRS cookie
   * @returns String
   */
  getToken() {
    LOG('[ GZHBase ]', 'getToken');
    return this.getCookie('wrs', false) ? decodeURIComponent(this.getCookie('wrs', false)) : false;
  }
  setToken(token, options) {
    LOG('[ GZHBase ]', 'setToken', token, options);
    this.setCookieWRS('wrs', token, { expires: this.getExpirationDate() });
  }
  /**
   * Encode token to pass in url, api services requires that encode two times
   * @param token
   * @returns {string}
   */
  encodeToken(token) {
    LOG('[ GZHBase ]', 'encodeToken', token);
    return encodeURIComponent(encodeURIComponent(token));
  }
  /**
   * Abstract the fetch request to API`s
   * @param url
   * @param options
   * @returns {Promise.<TResult>}
   */
  fetch(url, options = {}) {
    LOG('[ GZHBase ]', 'fetch', url, options);
    const headers = { method: 'GET', mode: 'cors', ...options };
    const request = new Request(url, headers); //eslint-disable-line
    return fetch(request).then(response => response.json()); //eslint-disable-line
  }
  /**
   * Get expiration date to set cookie time
   * @param weeks Int
   * @returns {Date}
   */
  getExpirationDate(hours = false) {
    LOG('[ GZHBase ]', 'getExpirationDate', hours);
    const time = hours || this.expirationTimes;
    LOG('[ GZHBase ]', 'getExpirationDate', 'time', time);
    LOG('[ GZHBase ]', 'getExpirationDate', 'addHours', addHours(this.expiration_date, time));
    return addHours(this.expiration_date, time);
  }

  /**
   * Get expiration Date instance
   * @returns {Date}
   */
  getExpiration() {
    return this.expiration_date;
  }
  /**
   * @param Cookie name
   * @param json if true return object otherwise a string
   * @returns {*} || String
   */
  getCookie(name, json = true) {
    LOG('[ GZHBase ]', 'getCookie', name, json);
    // use getJSON from Cookie api to return a object
    return json ? Cookie.getJSON(name) : Cookie.get(name);
  }
  /**
   * Abstract the Cookie library set method
   * @param name
   * @param obj
   * @param attributes
   * @returns {*}
   */
  setCookie(name, obj, attributes) {
    LOG('[ GZHBase ]', 'setCookie', name, obj, attributes);
    const ATTR = {
      domain: this.getCookieDomain(),
      ...attributes
    };
    return Cookie.set(name, obj, ATTR);
  }
  /**
   * Abstract Cookie Library remove method
   * @param name
   * @returns {*}
   */
  deleteCookie(name, attributes) {
    LOG('[ GZHBase ]', 'deleteCookie', name, attributes);
    const ATTR = {
      domain: this.getCookieDomain(),
      ...attributes
    };
    return Cookie.remove(name, ATTR);
  }
  /**
   * Return Cookie domain host
   * @returns {string}
   */
  getCookieDomain() {
    LOG('[ GZHBase ]', 'getCookieDomain', this._cookieDomain);
    return this._cookieDomain;
  }
  /*
  * Salva o cookie do WRS de uma maneira mais simples para manter a estrutura do LEGADO!
   */
  setCookieWRS(name, value, ATTR) {
    LOG(['GZHBase'], 'setCookieWRS', name, value, ATTR);
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${ATTR.expires ? ATTR.expires.toUTCString() : ATTR.expires}; domain=${ATTR.domain ? ATTR.domain : this.getCookieDomain()}; path=/;`; // eslint-disable-line
  }
}
export default GZHBase;
